module.exports = __webpack_public_path__ + "static/img/zdhf09.4708a03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/zdhf09.png
// module id = 127
// module chunks = 0